import React from 'react';
import { AppLayout } from '../components/AppLayout';
import LandingHeader from '../components/LandingHeader';
import Footer from '../../components/Footer';
import { isIOSDevice } from '../utils/deviceDetection';
import { useAuth } from '../components/AuthProviderWrapper';
import { BackButton } from '../components/BackButton';
import {
  BasicTermsSection,
  BusinessTermsSection,
  AlexaSkillSection,
  LegalDisclaimersSection,
  ClosingTermsSection,
} from './TermsOfService/index';

const TermsOfService: React.FC = () => {
  const isIOS = isIOSDevice();
  const { isAuthenticated } = useAuth();
  
  const content = (
    <div className="max-w-4xl mx-auto px-4" style={{ 
      paddingTop: isAuthenticated && isIOS ? '5rem' : '2rem', 
      paddingBottom: '2rem' 
    }}>
      <div className="mb-4">
        <BackButton />
      </div>
      <h1 className="text-3xl font-bold mb-6 text-gray-800">Terms of Service</h1>
      
      <div className="bg-white rounded-lg shadow-sm p-6 space-y-6">
        <div>
          <p className="text-gray-600 mb-4">
            <strong>Last Updated:</strong> January 2025
          </p>
          <p className="text-gray-600">
            These Terms of Service (&ldquo;Terms&rdquo;) govern your use of DinnerBrain (&ldquo;the Service&rdquo;) operated by 
            DinnerBrain (&ldquo;we&rdquo;, &ldquo;our&rdquo;, or &ldquo;us&rdquo;). By accessing or using our Service, you agree to be bound by these Terms.
          </p>
        </div>

        <BasicTermsSection />
        <BusinessTermsSection />
        <AlexaSkillSection />
        <LegalDisclaimersSection />
        <ClosingTermsSection />
      </div>
    </div>
  );

  // If logged in, use AppLayout with regular header
  if (isAuthenticated) {
    return (
      <AppLayout>
        {content}
      </AppLayout>
    );
  }

  // If logged out, use LandingHeader
  return (
    <div className="min-h-screen bg-white">
      <LandingHeader />
      <div style={{ 
        paddingTop: isIOS ? 'calc(5rem + env(safe-area-inset-top, 0px))' : '5rem'
      }}>
        {content}
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService;